/**
 * Opciones compartidas de los formularios de signup.
 *
 * Lista única de "How did you hear about us?" — la consumen tanto el
 * SignUpWizard (signup plano) como el formulario de referral de
 * homeowners (client/sign_up.vue). Antes estaba duplicada en ambos
 * archivos. "Other" siempre va al final como escape hatch — al elegirlo
 * los formularios muestran un input de texto libre.
 */
export const HEAR_ABOUT_OPTIONS = [
  'My Real Estate Agent',
  'Friend',
  'Family',
  'Social Media',
  'Kiey.com',
  'Postcard',
  'Flyer',
  'Google',
  'Vendor',
  'Other',
];
